import { legacy_createStore as createStore, combineReducers, applyMiddleware } from "redux";
import productReducer from "../reducers/productReducer";
import thunk from 'redux-thunk';


const logger = (store) => (next) => (action) => {
    console.log("dispatching", action);
    let result = next(action);
    console.log("next state", store.getState());
    return result;
};

const rootReducer = combineReducers({
    product: productReducer,
});

let store = createStore(rootReducer, applyMiddleware(logger, thunk));

export default store;
